import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children: React.ReactNode;
}

export const TableViewRow = (props: Props) => {
    return <S_TableViewRow className={props.className}>{props.children}</S_TableViewRow>;
};

const S_TableViewRow = styled.div`
    display: flex;
    padding: 10px 0;
    &:not(:last-child) {
        border-bottom: 1px solid #e4dcdc;
    }
`;
